"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notEdgeDesktop = void 0;
const constants_1 = require("../ngx-device-detector/constants");
function notEdgeDesktop(client) {
    return client.browser !== constants_1.BROWSERS.MS_EDGE || !client.isDesktop;
}
exports.notEdgeDesktop = notEdgeDesktop;
//# sourceMappingURL=not-edge-desktop.js.map